import axios from 'axios';
import { getCookie } from '@/utils/cookieUtils.js';
import { createApp, h } from 'vue';
import LoadingOverlay from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

// Loader instance variables
let loaderApp = null;
let loaderMountEl = null;
let activeRequests = 0;

function showLoader() {
    if (activeRequests === 0) {
        loaderMountEl = document.createElement('div');
        document.body.appendChild(loaderMountEl);

        loaderApp = createApp({
            render() {
                return h(LoadingOverlay, {
                    active: true,
                    canCancel: false,
                    color: '#007bff',
                    loader: 'dots',
                    color: '#3f4f9f',
                    width: 100,
                    height: 100,
                    backgroundColor: '#ffffff',
                    zIndex: 999
                   
                });
            },
        });
        loaderApp.mount(loaderMountEl);
    }
    activeRequests++;
}

function hideLoader() {
    activeRequests = Math.max(activeRequests - 1, 0);
    if (activeRequests === 0 && loaderApp && loaderMountEl) {
        loaderApp.unmount();
        document.body.removeChild(loaderMountEl);
        loaderApp = null;
        loaderMountEl = null;
    }
}

const instance = axios.create({
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

instance.interceptors.request.use(
    config => {
        showLoader();
      
        const token = getCookie('X-CSRF-TOKEN');
        if (token) {
            config.headers['x-csrf-token'] = `${token}`;
        }
        return config;
    },
    error => {
        hideLoader();
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    response => {
        hideLoader();
        console.log('[Axios Response]', response);
        return response;
    },
    error => {
        hideLoader();
        console.error('[Axios Error]', error);

        if (error.response) {
            console.error('[Axios Error Status]', error.response.status);
            console.error('[Axios Error Data]', error.response.data);
            console.error('[Axios Error Headers]', error.response.headers);

            if (error.response.status === 401) {
                console.warn('Unauthorized: Redirect to login or refresh token');
            }
        } else if (error.request) {
            console.error('[Axios Error] No response received:', error.request);
        } else {
            console.error('[Axios Error] Setup error:', error.message);
        }

        return Promise.reject(error);
    }
);

export default {
    install(app) {
        app.config.globalProperties.$axios = instance;
    },
};

export const axiosInstance = instance;
